import { useState } from 'react';

const useCustomHook = () => {
  const [guildsList, setGuildsList] = useState([]);
  const [walletsList, setWalletsList] = useState([]);
  const [guildListLoading, setGuildListLoading] = useState(false);

  return {
    guildsList,
    setGuildsList,
    walletsList,
    setWalletsList,
    guildListLoading,
    setGuildListLoading,
  };
};

export default useCustomHook;
